import { FREE_GAMES_DEFAULTS, LOCK_AND_ROLL_DEFAULTS } from '@GameStore/Defaults';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { ESpecialGamesType } from '@GFTypes/SpecialGames';
export type TSpecialGameIntro = EGameStoreKeys.IsFreeGamesIntro;
export type TSpecialGameOutro = EGameStoreKeys.IsFreeGamesOutro;

export type TSpecialGameMode = EGameStoreKeys.IsLockAndRollMode | EGameStoreKeys.IsFreeGamesMode;
export type TSpecialGameStore = EGameStoreKeys.LockAndRoll | EGameStoreKeys.FreeGames;
export type TSpecialGameGamestoreDefaults = typeof FREE_GAMES_DEFAULTS | typeof LOCK_AND_ROLL_DEFAULTS;

export enum ESpecialGameTextVariablePrefixes {
    RESPINS = 'respins',
    FREE_GAMES = 'freeGames',
    WILD_WALL = 'wildWall',
    LOCK_AND_ROLL = 'lockAndRoll',
    BONUS_PICK = 'bonusPick'
}

export const SPECIAL_GAME_MODE_FLAGS = new Map<ESpecialGamesType, TSpecialGameMode>([
    [ESpecialGamesType.RESPINS, EGameStoreKeys.IsFreeGamesMode],
    [ESpecialGamesType.FREE_GAMES, EGameStoreKeys.IsFreeGamesMode],
    [ESpecialGamesType.WILD_WALL, EGameStoreKeys.IsFreeGamesMode],
    [ESpecialGamesType.LOCK_AND_ROLL, EGameStoreKeys.IsLockAndRollMode],
    [ESpecialGamesType.BONUS_PICK, EGameStoreKeys.IsFreeGamesMode]
]);

export const SPECIAL_GAME_INTRO_FLAGS = new Map<ESpecialGamesType, TSpecialGameIntro>([
    [ESpecialGamesType.RESPINS, EGameStoreKeys.IsFreeGamesIntro],
    [ESpecialGamesType.FREE_GAMES, EGameStoreKeys.IsFreeGamesIntro],
    [ESpecialGamesType.WILD_WALL, EGameStoreKeys.IsFreeGamesIntro],
    [ESpecialGamesType.LOCK_AND_ROLL, EGameStoreKeys.IsFreeGamesIntro],
    [ESpecialGamesType.BONUS_PICK, EGameStoreKeys.IsFreeGamesIntro]
]);

export const SPECIAL_GAME_OUTRO_FLAGS = new Map<ESpecialGamesType, TSpecialGameOutro>([
    [ESpecialGamesType.RESPINS, EGameStoreKeys.IsFreeGamesOutro],
    [ESpecialGamesType.FREE_GAMES, EGameStoreKeys.IsFreeGamesOutro],
    [ESpecialGamesType.WILD_WALL, EGameStoreKeys.IsFreeGamesOutro],
    [ESpecialGamesType.LOCK_AND_ROLL, EGameStoreKeys.IsFreeGamesOutro],
    [ESpecialGamesType.BONUS_PICK, EGameStoreKeys.IsFreeGamesOutro]
]);

export const SPECIAL_GAME_CONFIGS_GAMESTORE_KEYS = new Map<ESpecialGamesType, TSpecialGameStore>([
    [ESpecialGamesType.RESPINS, EGameStoreKeys.FreeGames],
    [ESpecialGamesType.FREE_GAMES, EGameStoreKeys.FreeGames],
    [ESpecialGamesType.WILD_WALL, EGameStoreKeys.FreeGames],
    [ESpecialGamesType.LOCK_AND_ROLL, EGameStoreKeys.LockAndRoll],
    [ESpecialGamesType.BONUS_PICK, EGameStoreKeys.FreeGames]
]);

export const SPECIAL_GAME_PREFIX_PER_TYPE = new Map<ESpecialGamesType, string>([
    [ESpecialGamesType.RESPINS, ESpecialGameTextVariablePrefixes.RESPINS],
    [ESpecialGamesType.FREE_GAMES, ESpecialGameTextVariablePrefixes.FREE_GAMES],
    [ESpecialGamesType.WILD_WALL, ESpecialGameTextVariablePrefixes.WILD_WALL],
    [ESpecialGamesType.LOCK_AND_ROLL, ESpecialGameTextVariablePrefixes.LOCK_AND_ROLL],
    [ESpecialGamesType.BONUS_PICK, ESpecialGameTextVariablePrefixes.BONUS_PICK]
]);

export const SPECIAL_GAME_GAMESTORE_DEFAULTS = new Map<ESpecialGamesType, TSpecialGameGamestoreDefaults>([
    [ESpecialGamesType.RESPINS, FREE_GAMES_DEFAULTS],
    [ESpecialGamesType.FREE_GAMES, FREE_GAMES_DEFAULTS],
    [ESpecialGamesType.WILD_WALL, FREE_GAMES_DEFAULTS],
    [ESpecialGamesType.LOCK_AND_ROLL, LOCK_AND_ROLL_DEFAULTS],
    [ESpecialGamesType.BONUS_PICK, FREE_GAMES_DEFAULTS]
]);
